import { MotionProps } from 'framer-motion';
import { TOP_BAR_TRANSITION_DURATION_SEC } from '../BaseTabPanel/constants';
import { ACTIONS_BAR_INITIAL_Y_AXIS_POSITION } from './constants';

const DEFAULT_ANIMATION_STATE = {
  y: ACTIONS_BAR_INITIAL_Y_AXIS_POSITION,
  opacity: 0,
};

export const actionsBarAnimationProps: MotionProps = {
  transition: {
    duration: TOP_BAR_TRANSITION_DURATION_SEC,
  },
  initial: DEFAULT_ANIMATION_STATE,
  animate: {
    y: 0,
    opacity: 1,
  },
  exit: DEFAULT_ANIMATION_STATE,
};
